import { LocationEntity } from '@admin/core/models';
import { Component } from '@angular/core';
import { CacBaseDialogComponent, CacDialogLayoutComponent } from '@controladad/ng-base';
import { TreeViewComponent } from "@admin/shared";
import { formControl } from '@al00x/forms';

export interface TreeDialogData {
  dataSourse: LocationEntity[];
  value: number | number[] | undefined;
  highlightedIds: number[];
};

export type TreeDialogResult = boolean;

@Component({
  selector: 'app-tree-dialog',
  imports: [CacDialogLayoutComponent, TreeViewComponent],
  templateUrl: './tree-dialog.component.html',
})
export class TreeDialogComponent extends CacBaseDialogComponent<TreeDialogData, TreeDialogResult> {
  locationControl = formControl<number | number[] | undefined>(this.data.value);
}
